<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">可以使用的优惠券</h1>
    </nav>
    <div class="content">
      <div class="list-block media-list" id="myCoupons" style="margin-top: 0px;">
        <ul>
          <li v-for="(coupon, index) in myCoupons" :id="index" @click="getCoupon(index)">
            <div class="item-content">
              <div class="item-inner">
                <div v-if="coupon.applied == 0">
                  <div class="item-title-row">
                    <div class="item-title" style="color: #0894EC;">{{coupon.label}}</div>
                    <div class="item-after" v-if="coupon.type != 0">{{coupon.value | currencyStyle}}</div>
                  </div>
<!--                  <div class="item-subtitle">优惠码：{{coupon.code}}</div>-->
                  <div class="item-text" style="height: 1rem">有效期： 至 {{coupon.endDT}}</div>
                  <div >描述：{{coupon.label}}</div>
                </div>
                <div v-else="coupon.applied == 1">
                  <div class="item-title-row">
                    <div class="item-title" style="color: #0894EC;margin-top: 0.2rem;">{{coupon.label}}</div>
                    <div class="item-after" v-if="coupon.type != 0" style="margin-top: 15px;">{{coupon.value | currencyStyle}}</div>
                    <div>
                      <img src="/emktResources/resocurces/img/used_img.jpg" style="height: 70px;width: 70px">
                    </div>
                  </div>
<!--                  <div class="item-subtitle" style="margin-top: -2rem;">优惠码：{{coupon.code}}</div>-->
                  <div class="item-text" style="height: 1rem">有效期： 至 {{coupon.endDT}}</div>
                  <div >描述：{{coupon.label}}</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
  </div>
  </div>
</template>

<script>
  import Emkt from '../../../emkt.js'
  import $ from 'jquery'
  export default {
    created () {
      this.fetchData()
    },
    mounted () {
    },
    data () {
      return {
        myCoupons: []
      }
    },
    computed: {
    },
    watch: {
    },
    methods: {
      fetchData () {
        let myOrderCoupons = JSON.parse(this.$route.query.myOrderCoupons)
        if (myOrderCoupons) {
          this.myCoupons = myOrderCoupons
        }
      },
      getCoupon (index) {
        Emkt.setStoreItem('myCoupons', this.myCoupons[index])
        $('ul li')[index].style.background = 'grey'
        this.$router.go(-1)
      }
    },
    filters: {
      currencyStyle (val) {
        return ' ¥ ' + val
      }
    }
  }

</script>

<style scoped>
  .top{
    margin-top: -21px;
  }
</style>



// WEBPACK FOOTER //
// MyOrderCoupons.vue?43c3982e